export default __webpack_public_path__ + "static/media/group-faces.9e566071.png";